<div class="supply-product-page mat-elevation-z2">
  <div class="header">
    <div>
      <p class="eyebrow">Inventory Desk</p>
      <h2>Supply Product Setup</h2>
      <p class="subtitle">Maintain catalog structure, live stock positions, reorder points, and item measurement units.</p>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="forms-grid">
    <div class="form-card">
      <h3>Create Product Type</h3>
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Product Type</mat-label>
          <input matInput [(ngModel)]="createTypeName" placeholder="e.g. Vegetables" />
        </mat-form-field>
        <button mat-flat-button color="primary" (click)="addType()">Add Type</button>
      </div>
    </div>

    <div class="form-card">
      <h3>Create Item Type</h3>
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Product Type</mat-label>
          <mat-select [(value)]="createItemProductTypeId">
            <mat-option [value]="null">Select Type</mat-option>
            <mat-option *ngFor="let t of productTypes" [value]="t.id">{{ t.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Item Name</mat-label>
          <input matInput [(ngModel)]="createItemName" placeholder="e.g. Tomato" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Current Stock</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="createItemStock" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Reorder Level</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="createItemReorderLevel" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Unit Label</mat-label>
          <input matInput [(ngModel)]="createItemUnitLabel" placeholder="bags, cartons, kg" />
        </mat-form-field>
        <button mat-flat-button color="accent" (click)="addItem()">Add Item</button>
      </div>
    </div>
  </div>

  <div class="table-card">
    <h3>Product Types</h3>
    <table mat-table [dataSource]="productTypes" class="full-table mat-elevation-z1">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <ng-container matColumnDef="totalItems">
        <th mat-header-cell *matHeaderCellDef>Item Count</th>
        <td mat-cell *matCellDef="let row">{{ row.totalItems }}</td>
      </ng-container>

      <ng-container matColumnDef="totalStock">
        <th mat-header-cell *matHeaderCellDef>Total Stock</th>
        <td mat-cell *matCellDef="let row">{{ row.totalStock | number:'1.0-2' }}</td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef>Last Update</th>
        <td mat-cell *matCellDef="let row">{{ (row.updatedAt || row.createdAt) | date:'short' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="typeMenu">
            <mat-icon>menu</mat-icon>
          </button>
          <mat-menu #typeMenu="matMenu">
            <button mat-menu-item (click)="editType(row)">
              <mat-icon>edit</mat-icon>
              <span>Edit Type</span>
            </button>
            <button mat-menu-item (click)="deleteType(row)">
              <mat-icon>delete</mat-icon>
              <span>Delete Type</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="typeColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: typeColumns"></tr>
    </table>
  </div>

  <div class="table-card">
    <h3>Product Items</h3>
    <table mat-table [dataSource]="productItems" class="full-table mat-elevation-z1">
      <ng-container matColumnDef="productType">
        <th mat-header-cell *matHeaderCellDef>Product Type</th>
        <td mat-cell *matCellDef="let row">{{ row.productTypeName }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Item Type</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <ng-container matColumnDef="stock">
        <th mat-header-cell *matHeaderCellDef>Stock</th>
        <td mat-cell *matCellDef="let row">
          <span class="stock-pill" [ngClass]="stockStatus(row).toLowerCase()">
            {{ row.currentStock | number:'1.0-2' }} {{ row.unitLabel || 'units' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="reorderLevel">
        <th mat-header-cell *matHeaderCellDef>Reorder</th>
        <td mat-cell *matCellDef="let row">{{ row.reorderLevel | number:'1.0-2' }}</td>
      </ng-container>

      <ng-container matColumnDef="unitLabel">
        <th mat-header-cell *matHeaderCellDef>Unit</th>
        <td mat-cell *matCellDef="let row">{{ row.unitLabel || 'units' }}</td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef>Last Update</th>
        <td mat-cell *matCellDef="let row">{{ (row.updatedAt || row.createdAt) | date:'short' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="itemMenu">
            <mat-icon>menu</mat-icon>
          </button>
          <mat-menu #itemMenu="matMenu">
            <button mat-menu-item (click)="editItem(row)">
              <mat-icon>edit</mat-icon>
              <span>Edit Item</span>
            </button>
            <button mat-menu-item (click)="deleteItem(row)">
              <mat-icon>delete</mat-icon>
              <span>Delete Item</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="itemColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: itemColumns"></tr>
    </table>
  </div>
</div>
